import React, { useState } from 'react';
import ParentCardNoCol from '../../../common/ParentCardNoCol';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import showAlert from '../../../../common/utils/alert';

export const RefreshProject = ({ projectId, version, actions }) => {
  const [isLoading, setLoading] = useState(false);
  const handleProjectRefreshUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    const text = 'Refreshing Project will add newer features';
    const preConfirm = () => {
      actions.refreshProject({ projectId, version }).then(() => setLoading(false));
    };
    showAlert(text, preConfirm, 'Yes, Refresh!', 'warning');
  };
  return (
    <ParentCardNoCol title="Refresh Project" icon="reloadPage" bgColor="drapcode-violet">
      <div className="col-md-12 col-lg-12 mt-2 text-right d-flex justify-content-end">
        <button
          className="btn btn-theme-submit btn-md"
          disabled={isLoading}
          onClick={handleProjectRefreshUpdate}
        >
          <i className={`wb ${drapcodeIcon('reloadPage')}`}></i>&nbsp;Refresh&nbsp;
        </button>
      </div>
    </ParentCardNoCol>
  );
};
